import {WidgetState} from "../widget.state";

export class LogoutWidgetState extends WidgetState {}